import createVtbCardBannerDictionary from '@widgets/vtb-banner/i18n/ru/create-vtb-card-banner.dic.json';
import earnMoneyBannerDictionary from '@widgets/vtb-banner/i18n/ru/earn-money-banner.dic.json';

export const advertisingBanner = {
  CREATE_VTB_CARD_BANNER: createVtbCardBannerDictionary,
  EARN_MONEY_BANNER: earnMoneyBannerDictionary,
};

export const advertisingBannerNamespaces = Object.keys(advertisingBanner);
